<template>
	<div class="checkout-minimal-container columns is-center">
		<template v-if="hasItems()">
			<div class="center-message">
				<p>How does everything look?</p>
			</div>
			<order-details ref="orderDetails"/>
			<offers />
			<item-list />
			<checkout-special-instructions />
			<BaseActions :actions="getCheckoutActions()" />
			<transition name="fade-down" mode="out-in">
				<div v-if="showRecieptDetails">
					<receipt-info :totals="totalsForCheckout()" />
				</div>
			</transition>
		</template>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import layoutMixin from '@Mixin/layoutMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	import accountMixin from '@Mixin/accountMixin';
	import checkoutMixin from '@Mixin/checkoutMixin';
	import modalMixin from '@Mixin/modalMixin';
	import paymentMixin from '@Mixin/paymentMixin';
	import cartMixin from '@Mixin/cartMixin';
	import headerMixin from '@Mixin/headerMixin';
	import addressMixin from '@Mixin/addressMixin';
	import ReceiptInfoVue from '@Checkout/ReceiptInfo.vue';
	import EmptyCart from "@Checkout/EmptyCart";
	import Offers from "@Checkout/Offers.vue";

	const CheckoutSpecialInstructions = ((resolve) => {
		require.ensure([], () => {
			resolve(require('@/components/checkout/CheckoutSpecialInstructions.vue'));
		});
	});
	const ItemListVue = (resolve) => {
		require.ensure([], () => {
			resolve(require('./ItemList.vue'));
		});
	};
	const OrderDetailsVue = (resolve) => {
		require.ensure([], () => {
			resolve(require('./CheckoutOrderDetails.vue'));
		});
	};
	const ProfileEditor = (resolve) => {
		require.ensure([], () => {
			resolve(require('@/components/account/ProfileEditor.vue'));
		});
	};
	export default {
		mixins: [
			layoutMixin,
			navigationMixin,
			accountMixin,
			checkoutMixin,
			modalMixin,
			paymentMixin,
			cartMixin,
			headerMixin,
			addressMixin,
		],
		components: {
			'empty-cart': EmptyCart,
			'item-list': ItemListVue,
			'order-details': OrderDetailsVue,
			'receipt-info': ReceiptInfoVue,
			'offers': Offers,
			'checkout-special-instructions': CheckoutSpecialInstructions,
		},
		data() {
			return {
				showRecieptDetails: false,
			};
		},
		methods: {
			handleOrderSuccess(response) {
				// TODO parse into model
				const order = response.order;
				const locationBase = order.location_base;
				this.$router.push({
					path: "/order/order-confirmation-mobile",
					query: {
						order_id: order.order_id,
						lb: locationBase,
					},
					params: {
						checkoutOrder: response,
					}
				});
			},
			handleClickReceiptDetails() {
				this.showRecieptDetails = !this.showRecieptDetails;
			},
			getCheckoutActions() {
				const showReceipt = this.showRecieptDetails;
				const accessoryName = (showReceipt) ? 'caretDown' : 'caretRight';
				return [
					{
						name: 'Receipt Details',
						value: '',
						accessory: accessoryName,
						clickHandler: this.handleClickReceiptDetails,
					},
				];
			},
			handleOrderError(message) {
				this.$modal.show("dialog", {
					title: 'Oops',
					text: `There was an error processing this order: ${message}`,
					buttons: [
						{
							title: "OK",
							handler: () => {
								EventBus.$emit('order-button-enabled');
								this.$modal.hide("dialog");
							},
						},
					],
				});
			},
			updateHeader() {
				this._setHeaderTitle('Checkout');
				this._setHeaderItems([
					{
						key: 'back',
						props: {
							route: 'home',
						},
					},
					'title',
					'account',
				]);
			},
		},
		mounted() {
			const validCheckout = this.validCheckoutUser;
			if (!validCheckout) {
				let loader = this.$loading.show({
					loader: 'bars',
					canCancel: true,
					onCancel: this.onCancel,
				});
				this.loginGateWithLoader(loader);
			}
			this.updateHeader();
			this.setRouteLayout({
				name: 'Checkout',
				value: 'MinimalCheckout',
			});
			this.setDefaultPaymentMethod();
			const $mainContainer = this.$root.$el.querySelector('#main-container');
			$mainContainer.style.padding = '0';
			$mainContainer.scrollTo(0,0);
			window.scrollTo(0,0);
			if (!this._hasBackRoute) {
				this._setBackRoute('home');
			}
			this._initializeCart();
		},
		created() {
			EventBus.$on('order-success', this.handleOrderSuccess);
			EventBus.$on('order-error', this.handleOrderError);
		},
		destroyed() {
			EventBus.$off('order-success');
			EventBus.$off('order-error');
		}
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/checkout';
	@import 'commonStyle/form';
	.checkout-minimal-container {
		display: flex;
		flex-direction: column;
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/CheckoutView/CheckoutMinimal.vue